import { ID, IntlMessage } from "../Intl";

export function length(value: string | null, min: number, max: number): IntlMessage | undefined {
  return value && (value.length < min || value.length > max)
    ? min === max
      ? ID("valid.length1", { min })
      : ID("valid.length2", { min, max })
    : undefined;
}
